import { render, staticRenderFns } from "./ContractorContact.vue?vue&type=template&id=23ba4470&scoped=true&"
import script from "./ContractorContact.vue?vue&type=script&lang=js&"
export * from "./ContractorContact.vue?vue&type=script&lang=js&"
import style0 from "./ContractorContact.vue?vue&type=style&index=0&id=23ba4470&lang=scss&scoped=true&"
import style1 from "./ContractorContact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba4470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23ba4470')) {
      api.createRecord('23ba4470', component.options)
    } else {
      api.reload('23ba4470', component.options)
    }
    module.hot.accept("./ContractorContact.vue?vue&type=template&id=23ba4470&scoped=true&", function () {
      api.rerender('23ba4470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/contractors/ContractorContact.vue"
export default component.exports